<script setup>
import {ref, defineProps, computed} from 'vue';
import {Calendar} from 'v-calendar';
import 'v-calendar/dist/style.css';
import States from '../constants/States';

const props = defineProps({
  trainings: {type: Array, default: () => []},
});

const hover = ref(false);

const datas = computed(() => {
  return props.trainings.map(item => {
    return {
      key: item.id,
      dot: false,
      popover: {
        label: item.description,
        visibility: 'click',
      },
      customData: item,
      dates: item.start_date,
    };
  });
});

const openLink = training => {
  let url = '';

  if (training.type == 'training')
    url = `training/viewTrainingPlan/${training.linkId}`;

  if (training.type == 'information')
    url = `training/viewInformation/${training.linkId}`;

  return `${window.appGlobal.baseUrl}/${url}`;
};
</script>
<template>
  <Calendar expanded :attributes="datas">
    <template #day-content="{day, attributes}">
      <span :class="day.isToday ? 'vc-day-active' : 'vc-day-inactive'">
        {{ day.day }}
      </span>
      <div
        v-for="attr in attributes"
        :key="attr.key"
        class="relative"
        @mouseover="hover = attr.key"
        @mouseleave="hover = false"
      >
        <p>
          <span
            :class="{
              'vc-day-training-planned': attr.customData.status == States[0].id,
              'vc-day-training-ongoing': attr.customData.status == States[1].id,
              'vc-day-training-closed': attr.customData.status == States[2].id,
            }"
          ></span>
          <a
            :href="openLink(attr.customData)"
            target="_blank"
            style="text-decoration:none; color: inherit;"
          >
            {{ attr.customData.title }}
          </a>
        </p>
        <transition>
          <div
            v-show="hover == attr.key && attr.customData.description != ''"
            class="popover"
          >
            {{ attr.customData.description }}
          </div>
        </transition>
      </div>
    </template>
  </Calendar>
</template>

<style lang="scss">
.relative {
  position: relative;
  cursor: pointer;
}

.popover {
  position: absolute;
  top: -2.25rem;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px;
  color: white;
  border-radius: 0.5rem;
  background: $oxd-primary-one-color;
}

.popover:after {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  content: '';
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid $oxd-primary-one-color;
  clear: both;
}

.vc-pane {
  background: #f6f6f6;
}

.vc-day {
  font-family: 'Nunito Sans';
  font-size: 12px;
  min-height: 125px;
  border: 1px solid $oxd-primary-one-alpha-10-color;
  padding-top: 0.25rem;
}

/*
.vc-day.on-top {
  border-top-width: 0px;
}

.vc-day.on-bottom {
  border-bottom-width: 0px;
}
*/

.vc-day-content {
  height: 8vh;
  width: 100%;
}

.vc-day-inactive {
  font-family: 'Nunito Sans';
  font-size: 12px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 0.85rem;
  margin-left: 10px;
  background-color: #f8f9fa;
  color: #929baa;
}

.vc-day-active {
  font-family: 'Nunito Sans';
  font-size: 12px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 0.85rem;
  margin-left: 10px;
  color: $oxd-primary-one-color;
  background-color: $oxd-primary-one-alpha-10-color;
}

.vc-day-training-planned {
  font-size: 9px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 0.85rem;
  margin-left: 10px;
  margin-right: 10px;
  background-color: #f59e0b;
}

.vc-day-training-ongoing {
  font-size: 9px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 0.85rem;
  margin-left: 10px;
  margin-right: 10px;
  background-color: #2bc708;
}

.vc-day-training-closed {
  font-size: 9px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 0.85rem;
  margin-left: 10px;
  margin-right: 10px;
  background-color: #1d4ed8;
}

.vc-day-information {
  font-family: 'Nunito Sans';
  font-size: 9px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 0.85rem;
  margin-left: 10px;
  margin-right: 10px;
  color: white;
  background-color: orange;
}

.vc-dot {
  display: none;
}
</style>
